import { Injectable } from "@angular/core";
import { LocalStorageService } from "../services/local-storage.service";
import {
  IRequestPwdRecovery,
  IResetPassword,
  IUserCredentials,
} from "../data-types/user.interface";
import { HttpClientService } from "./http-client.service";
import { EStorageType } from "../data-types/storage.enum";
import { ICoworking } from "../data-types/coworking.interface";
import { IBankInfo } from "../data-types/bank-info.interface";
import { IPriceType, ISpace, ISpaceType } from "../data-types/space.interface";
import { collapseTextChangeRangesAcrossMultipleVersions } from "typescript";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CoworkingService {
  static instance: CoworkingService = new CoworkingService();
  public newSpaceStatus: Subject<{ id: number; status: number }> = new Subject<{
    id: number;
    status: number;
  }>();
  public newCoworkingSelected = new Subject();
  public coworkingModified = new Subject();
  public newCoworkingAdded = new Subject();

  constructor() {
    return (CoworkingService.instance = CoworkingService.instance || this);
  }
  public async createCoworking(coworking: ICoworking): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body: ICoworking = coworking;
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async createBooking(booking): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "bookings";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = booking;
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async putCoworking(coworking: ICoworking, id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + id;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body: ICoworking = coworking;
      HttpClientService.instance
        .put(url, headers, body)
        .then((result: any) => {
          resolve(result);
          console.log("resolveeeeeeee");
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async createFirstCoworking(coworking: ICoworking): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/first";
      let headers: any = {};
      let body: ICoworking = coworking;
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async deleteSpace(spaceId: number, stateId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = `spaces/${spaceId}/status/${stateId}`;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .patch(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async pauseSpace(spaceId: number, value: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "spaces/" + spaceId + "/enable/" + value;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body: any = {};
      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          this.newSpaceStatus.next({ id: spaceId, status: value });
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addMedias(
    mediasFormData: FormData,
    coworkingId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/upload-files";
      let headers: any = {
        "content-type": "multipart/form-data",
      };
      let body = mediasFormData;

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async putMedias(
    mediasFormData: FormData,
    coworkingId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/upload-files";
      let headers: any = {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body = mediasFormData;

      HttpClientService.instance
        .patch(url, headers, body)
        .then((result: any) => {
          resolve(result);
          this.coworkingModified.next();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addSpaceImage(
    spaceImage: FormData,
    spaceId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "spaces/" + spaceId + "/upload-file";
      let headers: any = {
        "content-type": "multipart/form-data",
      };
      let body = spaceImage;

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addServices(services: any, coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/services";
      let headers: any = {};
      let body = { services: services };

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getSpaceTypes(): Promise<Array<ISpaceType>> {
    return new Promise((resolve, reject) => {
      let url: string = "spacetypes";
      let headers: any = {};

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getPriceTypes(): Promise<Array<IPriceType>> {
    return new Promise((resolve, reject) => {
      let url: string = "durations";
      let headers: any = {};

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addSpaces(spaces: ISpace, coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/spaces";
      let headers: any = {};
      let body: any = spaces;

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async putSpaces(spaces: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "spaces/all";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body: any = spaces;

      HttpClientService.instance
        .put(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async addBankInfo(
    encryptedData: string,
    coworkingId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/payment-info";
      let headers: any = {};
      let body: any = { data: encryptedData };

      HttpClientService.instance
        .post(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingInfo(coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingSpacesByCoworker(coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/spaces";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingSpaces(coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "cms/coworkings/" + coworkingId + "/spaces";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingBookings(coworkingId: string, params): Promise<any> {
    console.log(params);
    const newParams = {};
    if (params.pagination) {
      newParams["page"] = params.pagination.page;
    }

    if (params.space_id) {
      newParams["space_id"] = params.space_id.id;
    }

    if (params.state_id) {
      newParams["state_id"] = params.state_id.id;
    }

    if (params.dateStart) {
      newParams['dateStart'] = params.dateStart;
    }

    if (params.dateEnd) {
      newParams['dateEnd'] = params.dateEnd;
    }

    console.log("new params!!!", newParams);
    const queryparams = Object.keys(newParams)
      .filter((key) => newParams[key] !== null)
      .map((key) => key + "=" + newParams[key])
      .join("&");
    console.log(queryparams);
    return new Promise((resolve, reject) => {
      let url: string =
        "coworkings/" + coworkingId + "/bookings?" + queryparams;
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingServices(coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/services";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };

      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async getCoworkingPaymethods(coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/payment-info";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      HttpClientService.instance
        .get(url, headers)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public async putServices(services: any, coworkingId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let url: string = "coworkings/" + coworkingId + "/services";
      let headers: any = {
        Authorization: `Bearer ${LocalStorageService.instance.get(
          EStorageType.Token
        )}`,
      };
      let body: any = { services: services };

      HttpClientService.instance
        .put(url, headers, body)
        .then((result: any) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
